var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasiccharts53(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 64,
    viewBox: "0 0 102 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 33,
    width: 46,
    height: 27,
    rx: 2,
    fill: "#939BA7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 4,
    width: 46,
    height: 27,
    rx: 2,
    fill: "#939BA7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 22,
    height: 16,
    rx: 2,
    fill: "#939BA7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    width: 22,
    height: 16,
    rx: 2,
    fill: "#939BA7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 22,
    height: 18,
    rx: 2,
    fill: "#939BA7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 22,
    height: 18,
    rx: 2,
    fill: "#939BA7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 42,
    width: 22,
    height: 18,
    rx: 2,
    fill: "#939BA7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 22,
    height: 18,
    rx: 2,
    fill: "#939BA7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasiccharts53);
export default __webpack_public_path__ + "static/media/Basic charts-53.2b5c2261c9b21c7b97b60d949cff7b71.svg";
export { ForwardRef as ReactComponent };